module.exports = __webpack_public_path__ + "static/img/15.1aa25c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/zh/15.png
// module id = VU4G
// module chunks = 0